import { validatorTypes } from "common/shared";
import FormInput from "common/shared/interfaces/form-input";

export class ProfileInstitutionFormSchema {
  public country = new FormInput();
  public street1 = new FormInput();
  public street2 = new FormInput();
  public city = new FormInput();
  public region = new FormInput();
  public postalCode = new FormInput();
  public primaryContactUser = new FormInput();

  constructor(data: any, disabledFields: { [key: string]: boolean }) {
    if (data) {
      this.country.value = data.country || "";
      this.street1.value = data.street1 || "";
      this.street2.value = data.street2 || "";
      this.city.value = data.city || "";
      this.region.value = data.region || "";
      this.postalCode.value = data.postalCode || "";
      this.primaryContactUser.value = data.primaryContactUser || null;
    }

    if (disabledFields) {
      this.country.isDisabled = disabledFields.country || false;
      this.street1.isDisabled = disabledFields.street1 || false;
      this.street2.isDisabled = disabledFields.street2 || false;
      this.city.isDisabled = disabledFields.city || false;
      this.region.isDisabled = disabledFields.region || false;
      this.postalCode.isDisabled = disabledFields.postalCode || false;
      this.primaryContactUser.isDisabled = disabledFields.primaryContactUser || false;
    }
  }
}

export const institutionValidationSchema = {
  country: [],
  street1: [validatorTypes.streetPattern, validatorTypes.needOneCorrectLetter],
  street2: [validatorTypes.streetPattern, validatorTypes.needOneCorrectLetter],
  city: [validatorTypes.cityPattern, validatorTypes.needOneCorrectLetter],
  region: [],
  postalCode: [validatorTypes.postalCodePattern],
  primaryContactUser: [validatorTypes.required],
};

export const impersonateInstitutionDisabledConfig = {
  country: true,
  street1: true,
  street2: true,
  city: true,
  region: true,
  postalCode: true,
  primaryContactUser: true,
};
